import graphql__bbeb7e3a38d4d7d7e4ed from "./__generated__/PageSectionSidebarBanner_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";
import classNames from "classnames";

import { useSidebarSectionTitle } from "../PageSection/useSidebarSectionTitle";
import SlideshowCarousel from "../Carousel/SlideshowCarousel";

const PageSectionSidebarBanner = props => {
  const pageSection = useFragment(
    PageSectionSidebarBanner_pageSection,
    props.pageSection
  );
  const { slides, autoplay, slidesInterval, fullHeight } = pageSection;
  const { title } = useSidebarSectionTitle({ pageSection });

  const hasBox = title !== null;

  const className = classNames([
    "page-section",
    "page-section-sidebar-image",
    {
      "page-section-sidebar-box": hasBox,
      card: hasBox,
      box: hasBox,
      "box-image": hasBox,
      "full-height": fullHeight
    }
  ]);

  return (
    <div className={className}>
      {title}

      <SlideshowCarousel
        slides={slides}
        autoplay={autoplay}
        slidesInterval={slidesInterval}
      />
    </div>
  );
};

const PageSectionSidebarBanner_pageSection = graphql__bbeb7e3a38d4d7d7e4ed;

export default PageSectionSidebarBanner;
